import { alpha } from "@mui/system"
import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../../mp-core/themes/palette"

export const useStyles = makeStyles()(
  ({ spacing, breakpoints, mixins, palette }) => ({
    answerMaskingButton: {
      padding: spacing(4),
      minWidth: "54px",
      backgroundColor: blueGrey[50],
      border: `1px solid transparent`,
      borderRadius: "0px 3px 3px 0px",
      transition: "none",

      "&:hover": {
        backgroundColor: blueGrey[100]
      },
      "&:active": {
        backgroundColor: blueGrey[200]
      },
      "&:focus": {
        ...mixins.focusRing.outline,
        outline: `1px solid ${alpha(palette.focus, 0.2)}`
      },

      "& svg": {
        fontSize: "1.125rem"
      },

      [breakpoints.down("mobile")]: {
        minWidth: "41px",
        padding: spacing(2.25)
      }
    },
    answerMaskingOverlay: {
      position: "absolute",
      top: "0px",
      left: "0px",
      width: "100%",
      height: "100%",
      backgroundColor: blueGrey[100],
      borderRadius: "3px 0px 0px 3px"
    }
  })
)
